<div class="container container-slim">
  <div class="row">
    <div class="col-md-12">
      <h3 class="text-login text-login-default">Registrierung/Registration</h3>
    </div>
  </div>
    <form (ngSubmit)="onSubmit()" ngNativeValidate>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <div class="input-group">
              <span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span>
              <input type="email" class="form-control" name="email" id="inputEmail" [(ngModel)]="userInfo.email" placeholder="E-Mail/Email" required>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <div class="input-group">
              <span class="input-group-addon"><i class="glyphicon glyphicon-lock"></i></span>
              <input type="password" class="form-control" name="password" id="inputPassword" [(ngModel)]="userInfo.password" placeholder="Passwort/Password" required>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <password-strength-bar
                [passwordToCheck]="userInfo.password"
                [titlePrefix]="'Passwortstärke / password strenght: '">
          </password-strength-bar>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 form-group">
          <input type="text" class="form-control" name="firstname" id="inputFirstname" [(ngModel)]="userInfo.firstname" placeholder="Vorname/First Name" required>
        </div>
        <div class="col-md-6 form-group">
          <input type="text" class="form-control" name="lastname" id="inputLastname" [(ngModel)]="userInfo.lastname" placeholder="Nachname/Last Name" required>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 form-group">
          <label class="checkbox">
            <input type="checkbox" name="dsgvo" id="inputDsgvo" [(ngModel)]="userInfo.dsgvo" required> Hiermit willige ich in die Verarbeitung meiner personenbezogenen Daten zum Zweck der Nutzung der Leada-App ein.
              (<a href="https://www.leada.de/datenschutz" target="_blank">Datenschutzerklärung</a>) / <br/>
              I hereby give consent for my personal data to be processed for the purpose of using the Leada app.
              (<a href="https://www.synk-group.com/datenschutzerklaerung?lang=en" target="_blank">Data Protection Declaration</a>)
          </label>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12 form-group">
            <label class="checkbox">
              <input type="checkbox" name="newsletter" id="inputNewsetter" [(ngModel)]="userInfo.newsletter"> Ich möchte den Newsletter abonnieren. / I would like to subscribe to the newsletter.
            </label>
          </div>
        </div>
        <div class="row">
        <div class="col-md-12">
          <div *ngIf="error" class="alert alert-danger" role="alert">
            <span class="glyphicon glyphicon-exclamation-sign"></span>
            {{error}}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-block">
              Registrieren/Register
            </button>
          </div>
        </div>
      </div>
  </form>
</div>
